export const MAILINGS_PAGINATION = {
  PAGES_LIMIT: 20,
};

export const MAILINGS_LIST_FIELDS = {
  MAILINGS: "mailings",
  MESSAGES: "messages",
  COUNT: "count",
};

export const MAILINGS_WRAPPER_FIELDS = {
  MAILINGS_LIST: "mailingsList",
};

export const MAILING_ITEM_FIELDS = {
  ID: "id",
  STATUS: "status",
  AUDIENCE_ID: "audienceId",
  SUBSCRIPTION_ID: "subscriptionId",
};

export const MAILING_STATUSES = {
  SEND: 0,
  DRAFT: 1,
  QUEUED: 2,
  FAILED: 3,
  PAUSED: 4,
  SCHEDULED: 5,
  REGULAR: 6,
  RSS: 7,
  RSS_PAUSED: 8,
  RSS_ITEM: 9,
  RSS_ITEM_PAUSED: 10,
};

export const TYPE_MAILING = {
  GENERAL: 0,
  RSS: 2,
};
